import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import "core-js/modules/es.array.sort.js";

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

import { IMarkerService, MarkerSeverity } from '../../../platform/markers/common/markers.js';
import { URI } from '../../../base/common/uri.js';
import { Emitter } from '../../../base/common/event.js';
import { DisposableStore } from '../../../base/common/lifecycle.js';
import { Range } from '../../common/core/range.js';
import { compare } from '../../../base/common/strings.js';
import { binarySearch } from '../../../base/common/arrays.js';
import { createDecorator } from '../../../platform/instantiation/common/instantiation.js';
import { registerSingleton } from '../../../platform/instantiation/common/extensions.js';
import { LinkedList } from '../../../base/common/linkedList.js';
export var MarkerCoordinate = function MarkerCoordinate(marker, index, total) {
  _classCallCheck(this, MarkerCoordinate);

  this.marker = marker;
  this.index = index;
  this.total = total;
};

var MarkerList = /*#__PURE__*/function () {
  function MarkerList(resourceFilter, _markerService) {
    var _this = this;

    _classCallCheck(this, MarkerList);

    this._markerService = _markerService;
    this._onDidChange = new Emitter();
    this.onDidChange = this._onDidChange.event;
    this._dispoables = new DisposableStore();
    this._markers = [];
    this._nextIdx = -1;

    if (URI.isUri(resourceFilter)) {
      this._resourceFilter = function (uri) {
        return uri.toString() === resourceFilter.toString();
      };
    } else if (resourceFilter) {
      this._resourceFilter = resourceFilter;
    }

    var updateMarker = function updateMarker() {
      _this._markers = _this._markerService.read({
        resource: URI.isUri(resourceFilter) ? resourceFilter : undefined,
        severities: MarkerSeverity.Error | MarkerSeverity.Warning | MarkerSeverity.Info
      });

      if (typeof resourceFilter === 'function') {
        _this._markers = _this._markers.filter(function (m) {
          return _this._resourceFilter(m.resource);
        });
      }

      _this._markers.sort(MarkerList._compareMarker);
    };

    updateMarker();

    this._dispoables.add(_markerService.onMarkerChanged(function (uris) {
      if (!_this._resourceFilter || uris.some(function (uri) {
        return _this._resourceFilter(uri);
      })) {
        updateMarker();
        _this._nextIdx = -1;

        _this._onDidChange.fire();
      }
    }));
  }

  _createClass(MarkerList, [{
    key: "dispose",
    value: function dispose() {
      this._dispoables.dispose();

      this._onDidChange.dispose();
    }
  }, {
    key: "matches",
    value: function matches(uri) {
      if (!this._resourceFilter && !uri) {
        return true;
      }

      if (!this._resourceFilter || !uri) {
        return false;
      }

      return this._resourceFilter(uri);
    }
  }, {
    key: "selected",
    get: function get() {
      var marker = this._markers[this._nextIdx];
      return marker && new MarkerCoordinate(marker, this._nextIdx + 1, this._markers.length);
    }
  }, {
    key: "_initIdx",
    value: function _initIdx(model, position, fwd) {
      var found = false;

      var idx = this._markers.findIndex(function (marker) {
        return marker.resource.toString() === model.uri.toString();
      });

      if (idx < 0) {
        idx = binarySearch(this._markers, {
          resource: model.uri
        }, function (a, b) {
          return compare(a.resource.toString(), b.resource.toString());
        });

        if (idx < 0) {
          idx = ~idx;
        }
      }

      for (var i = idx; i < this._markers.length; i++) {
        var range = Range.lift(this._markers[i]);

        if (range.isEmpty()) {
          var word = model.getWordAtPosition(range.getStartPosition());

          if (word) {
            range = new Range(range.startLineNumber, word.startColumn, range.startLineNumber, word.endColumn);
          }
        }

        if (position && (range.containsPosition(position) || position.isBeforeOrEqual(range.getStartPosition()))) {
          this._nextIdx = i;
          found = true;
          break;
        }

        if (this._markers[i].resource.toString() !== model.uri.toString()) {
          break;
        }
      }

      if (!found) {
        // after the last change
        this._nextIdx = fwd ? 0 : this._markers.length - 1;
      }

      if (this._nextIdx < 0) {
        this._nextIdx = this._markers.length - 1;
      }
    }
  }, {
    key: "resetIndex",
    value: function resetIndex() {
      this._nextIdx = -1;
    }
  }, {
    key: "move",
    value: function move(fwd, model, position) {
      if (this._markers.length === 0) {
        return false;
      }

      var oldIdx = this._nextIdx;

      if (this._nextIdx === -1) {
        this._initIdx(model, position, fwd);
      } else if (fwd) {
        this._nextIdx = (this._nextIdx + 1) % this._markers.length;
      } else if (!fwd) {
        this._nextIdx = (this._nextIdx - 1 + this._markers.length) % this._markers.length;
      }

      if (oldIdx !== this._nextIdx) {
        return true;
      }

      return false;
    }
  }, {
    key: "find",
    value: function find(uri, position) {
      var idx = this._markers.findIndex(function (marker) {
        return marker.resource.toString() === uri.toString();
      });

      if (idx < 0) {
        return undefined;
      }

      for (; idx < this._markers.length; idx++) {
        if (Range.containsPosition(this._markers[idx], position)) {
          return new MarkerCoordinate(this._markers[idx], idx + 1, this._markers.length);
        }
      }

      return undefined;
    }
  }], [{
    key: "_compareMarker",
    value: function _compareMarker(a, b) {
      var res = compare(a.resource.toString(), b.resource.toString());

      if (res === 0) {
        res = MarkerSeverity.compare(a.severity, b.severity);
      }

      if (res === 0) {
        res = Range.compareRangesUsingStarts(a, b);
      }

      return res;
    }
  }]);

  return MarkerList;
}();

MarkerList = __decorate([__param(1, IMarkerService)], MarkerList);
export { MarkerList };
export var IMarkerNavigationService = createDecorator('IMarkerNavigationService');

var MarkerNavigationService = /*#__PURE__*/function () {
  function MarkerNavigationService(_markerService) {
    _classCallCheck(this, MarkerNavigationService);

    this._markerService = _markerService;
    this._provider = new LinkedList();
  }

  _createClass(MarkerNavigationService, [{
    key: "getMarkerList",
    value: function getMarkerList(resource) {
      var _iterator = _createForOfIteratorHelper(this._provider),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var provider = _step.value;
          var result = provider.getMarkerList(resource);

          if (result) {
            return result;
          }
        } // default

      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return new MarkerList(resource, this._markerService);
    }
  }]);

  return MarkerNavigationService;
}();

MarkerNavigationService = __decorate([__param(0, IMarkerService)], MarkerNavigationService);
registerSingleton(IMarkerNavigationService, MarkerNavigationService, true);